<span class="text-3xl">{{ 'insights.title' | translate }}</span>

<p>{{ 'insights.description' | translate }}</p>
<button
  kendoButton
  themeColor="primary"
  class="uppercase"
  maximizerShowcaseBookDemo
>
  {{ 'insights.button.action' | translate }}
</button>
